import { Directive, input } from '@angular/core';
import { OverlayTriggerBase } from './overlay-trigger-base.directive';

@Directive({
  selector: '[fcOverlayClick]',
  standalone: true,
  exportAs: 'fcOverlayClick',
  host: {
    '(click)': 'onClick()',
    '(document:click)': 'onDocumentClick($event)',
    '(keydown.escape)': 'onEscape($event)',
  },
})
export class OverlayClickDirective extends OverlayTriggerBase {
  /** When true, the trigger ignores clicks. Consumers grey the host out. */
  readonly disabled = input(false);

  protected onClick(): void {
    if (this.disabled()) return;
    this.toggleOverlay();
  }

  protected onDocumentClick(event: Event): void {
    if (!this.isOpen()) return;
    if (!(event.target instanceof Element)) return;

    const target: Element = event.target;
    const clickedTrigger = this.elementRef.nativeElement.contains(target);
    const clickedOverlay = this.overlayElement?.contains(target);

    // Ignore clicks in a separate CDK overlay pane (e.g. a timepicker popup),
    // but not clicks within the same pane as our trigger (e.g. inside a MatDialog).
    const hostPane = this.elementRef.nativeElement.closest('.cdk-overlay-pane');
    const targetPane = target.closest('.cdk-overlay-pane');
    const clickedExternalCdkOverlay =
      !!target.closest('.cdk-overlay-container') && targetPane !== hostPane;

    if (!clickedTrigger && !clickedOverlay && !clickedExternalCdkOverlay) {
      this.hideOverlay();
    }
  }

  protected onEscape(event: Event): void {
    if (!this.isOpen()) return;
    event.stopPropagation();
    this.hideOverlay();
  }
}
